import React from 'react'
import { Redirect } from 'react-router-dom'
import { isTokenExpirado } from '../localstorage/localstorage.service'
import { isRouteAllowed } from '../permission/menus'
import NotAllowedScreen from '../../components/NotAllowedScreen/NotAllowedScreen'

export function auth(component, user_action_id = null) {
  if (isTokenExpirado()) return <Redirect to="/" />
  if (!isRouteAllowed(user_action_id)) return <NotAllowedScreen />
  return component
}
